<template lang="html">
  <section class="vh intro flex wrap justify-center">
    <img
      class="w-100"
      src="/static/img/bkg/bkg-catalogo.webp"
      :alt="$t('catalogo.alt_images.catalog')"
    />
    <a href="#" v-scroll-to="'.cat-general'" class="scrolldown"></a>
    <div class="col-50 flex column justify-center animated fadeInLeft">
      <div class="container-text">
        <h1 class="title title-52 -color-yellow">
          {{ $t("catalogo.intro.titulo") }}
        </h1>

        <p v-html="$t('catalogo.intro.texto')"></p>

        <ul class="menu-catalogo flex row justify-start">
          <li>
            <a v-scroll-to="'.cat-general'">{{
              $t("enlaces.textos.catalogo_general")
            }}</a>
          </li>
          <li>
            <a v-scroll-to="'.cat-turbo'">{{
              $t("enlaces.textos.catalogo_turbos")
            }}</a>
          </li>

          <li>
            <a target="_blank" :href="$t('enlaces.catalogo_online')">{{
              $t("enlaces.textos.tec_alliance")
            }}</a>
          </li>
          <li>
            <a
              target="_blank"
              href="/static/pdf/ajusa-electric-engine-catalogue.pdf"
              >{{ $t("enlaces.textos.catalogo_motor_electrico") }}</a
            >
          </li>
          <li>
            <a
              target="_blank"
              href="/static/pdf/ajusa-a_ccompressor-catalogue.pdf"
              >{{ $t("enlaces.textos.catalogo_comprensorAC") }}</a
            >
          </li>
        </ul>

        <button
          class="openDeplegable"
          @click="toggleOtrosCatalagos"
          :open="otrosCatalogos"
        >
          <p class="titleCatalogos ">
            {{ $t("enlaces.textos.otrosCatalogos") }}
          </p>
          <img src="/static/img/scrolldown.svg" />
        </button>
        <ul
          v-if="otrosCatalogos"
          class="menu-catalogo flex row justify-start menu-desplegable"
        >
          <li>
            <a v-scroll-to="'.cat-juegos-juntas'">
              {{ $t("enlaces.textos.catalogo_juegosJuntas") }}</a
            >
          </li>
          <li>
            <a v-scroll-to="'.motorsport'">Motorsports</a>
          </li>
          <li>
            <a target="_blank" href="/static/pdf/copper-washer-catalog.pdf">{{
              $t("enlaces.textos.catalogo_arandelas")
            }}</a>
          </li>
          <li>
            <a target="_blank" href="/static/pdf/o-rings-catalog.pdf">{{
              $t("enlaces.textos.catalogo_toricas")
            }}</a>
          </li>
          <li>
            <a target="_blank" href="/static/pdf/oil-seals-catalog.pdf">{{
              $t("enlaces.textos.catalogo_retenes")
            }}</a>
          </li>
          <li>
            <a v-scroll-to="'.cat-juntas-compresor'">{{
              $t("enlaces.textos.catalogo_juntas_compresor")
            }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-50 flex column justify-center animated fadeInLeft">
      <div class="container-text -catalogoImpreso">
        <h2
          class="title title-36"
          v-html="$t('catalogo.intro.catalogo_impreso')"
        ></h2>
        <p>{{ $t("catalogo.intro.catalogo_impreso_texto") }}</p>
        <router-link
        class="btn btn-light -yellow-full"
          :to="$t('enlaces.contacto')"
          >{{ $t("catalogo.intro.catalogo_impreso_boton") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
export default {
  name: 'catalogo',
  props: [],
  mounted() {

  },
  data() {
    return {
      otrosCatalogos:false,
    }
  },
  methods: {
    toggleOtrosCatalagos() {
      this.otrosCatalogos = !this.otrosCatalogos
    }
  },
  computed: {
    ...mapGetters(['getServer', 'getLanguage']),
  }
}
</script>

<style scoped>
.titleCatalogos {
  margin: 30px 0 20px 0;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
}

.menu-catalogo {
  flex-wrap: wrap;
}

.menu-catalogo li {
  margin-bottom: 10px;
  width: 100%;
}

@media screen and (max-width: 1024px) {
  .titleCatalogos {
    margin: 30px 0 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/catalogo.vue